import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/Auth/forgotpassword";

export class GenerateForgotPasswordTokenCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GenerateForgotPasswordTokenReqData;

    constructor(username: string) {
        super();
        this.payload = new GenerateForgotPasswordTokenReqData(username);
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

class GenerateForgotPasswordTokenReqData {
    username: string;

    constructor(username: string) {
        this.username = username;
    }
}
